module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bBuQoD/tc-custom/9781685629878.jpg?1705688223105",
      "alt": "This image is the cover for the book Give Up Your Vows"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Give Up Your Vows\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("It’s an old question: Can a man and a woman just be colleagues, or friends, without taking it to the next level? It always starts innocently, an attraction that grows as they spend more time together. The couple enjoy each other’s company, and the connection builds and feelings develop. The anticipation grows, even if they are married. Decisions are made. What if the line is crossed? The excitement of being together is palatable. Sometimes temptation wins. Will couples stray and give up their promises to be with someone else? The big question is will it last, and was it worth the consequences? Are all the good ones taken? Do vows have an expiration date? Find out.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daniel Kneip\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("After most 30 years in home improvement management and at the pinnacle of his profession, Dan fulfilled a lifetime goal and switched careers to become a middle school teacher.")]), _c('p', [_vm._v("Dan has a BLS in History from the University of Mary Washington in Fredericksburg, Virginia and an MBA from Emory University in Atlanta, Georgia. Now retired, Dan lives in Richmond, Virginia, with his wife of 36 years, Sue.")]), _c('p', [_vm._v("Dan is the author of "), _c('em', [_vm._v("Public Education: Spending Less, Achieving Lesser (2001)")]), _vm._v(".")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0